import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	deleteButton: {
		id: 'bulk-operations-core.toolbar.use-bulk-delete-action.detele-button',
		defaultMessage: 'Delete',
		description:
			'Text on delete button in the bulk operations floating toolbar to delete multiple issues',
	},
});
